import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { CluPermissionService } from './clu-permission.service';
import { AuthService } from 'src/app/@auth/auth.service';
import { ROLE_WORKSPACE_USER } from 'src/app/app.models';

@Injectable({
    providedIn: 'root'
})
export class CluPermissionGuard implements CanActivate {
    routesPermissions = [
        { url: "/cluadmin/apps/p-admin/adm-sites", permissions: ["M_BACKOFFICE_SITE"], fallbackUrl: '/cluadmin/apps/p-admin/adm-sage-link' },
        { url: "/cluadmin/apps/p-admin/adm-sage-link", permissions: ["M_BACKOFFICE_LIAISON_SAGE"], fallbackUrl: '/cluadmin/apps/p-admin/adm-users' },
        { url: "/cluadmin/apps/p-admin/adm-users", permissions: ["M_BACKOFFICE_USERS"], fallbackUrl: '/cluadmin/apps/p-admin/adm-permissions' },
        { url: "/cluadmin/apps/p-admin/adm-permissions", permissions: ["M_BACKOFFICE_PERMISSIONS"] },
    ];
    constructor(
        private _authService: AuthService,
        private _cluPermissionService: CluPermissionService, 
        private _router: Router
    ) {
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        const authSessionDto = await this._authService.authenticatedSession$.value;
        if (!authSessionDto) {
            //await this._router.navigate(['/unauthorized'], { queryParams: { redirectUrl: state.url } });
            return true;
        }

        if (authSessionDto.ROLE_ID != ROLE_WORKSPACE_USER.SUPER_ADMIN_WORKSPACE) {
            const routePermission = this.routesPermissions.find(r => r.url == state.url);
            if (!!routePermission && !(await this._cluPermissionService.hasPermission(routePermission.permissions))) {
                if (!!routePermission.fallbackUrl) {
                    await this._router.navigateByUrl(routePermission.fallbackUrl);
                    return false;
                } else {
                    await this._router.navigate(['/unauthorized'], { queryParams: { redirectUrl: state.url } });
                    return false;
                }
            }
        }

        return true;
    }
}
